<template>
    <div class="custom-select-box" :tabindex="tabindex" ref="select-box" @focusout="handleFocusOut">
        <div class="selected" :class="{ open: open}" @click="open = !open">
            <b-button block variant="outline-primary" :disabled="getDropdownData.length === 0" class="mb-8" :name="`custom-dropdown-btn-${buttonText}`">{{buttonText}}</b-button>
        </div>
        <div ref="options" v-if="getDropdownData.length !== 0" class="items" :class="{ 'select-hide': !open }"  @click="open = !open">
            <div class="multi-select-height">
                <div class="item" v-for="data of getDropdownData" :key="`custom-dropdown-${data.id}`">
                    <label class="row">
                        <div class="col-1 pt-3 pl-0">
                          <input :id="data.id" :value="data" type="checkbox" v-model="selectedData">
                          <span class></span>
                        </div>
                        <div class="col-10 pl-4 pr-0">
                          <span class="fw-bold" :title="data.title">{{ data.title }}</span><br>
                          <span class="step-body" :title="data.subTitle">{{ data.subTitle }}</span>
                        </div>
                    </label>
                </div>
            </div>
            <div class="horizontal-divider"></div>
            <button :disabled="!selectedDataCount" :class="!selectedDataCount ? 'btn-opacity': ''" :name="`custom-dropdown-btn-${addButtonText}`" class="btn-block btn-primary mt-15 add-step-button" data-testid="custom-dropdown-add-btn" @click="addDrodownData($event)">{{ getAddButtonText }}</button>
        </div>
    </div>   
</template>

<script>
export default {
  name: "add-step-section-dropdown",
  data() {
    return {
      selectedData:[],
      open: false,
      tabindex: 0
    };
  },
  props:{
    buttonText:{
      type: String,
      required: true,
      default: ''
    },
    addButtonText:{
      type: String,
      required: true,
      default: ''
    },
    addButtonSingleText:{
      type: String,
      required: true,
      default: ''
    },
    dropdownContent:{
      type: Array,
      required: true,
      default: ()=>{ return []; }
    },
  },
  watch:{
    selectedData:{
      handler(value){
        this.$emit("onDropdownSelect", value);
      }
    }
  },
  computed: {
    selectedDataCount(){
      if(this.selectedData.length > 0){
        return this.selectedData.length;
      }
      else{
        return "";
      }
    },
    getDropdownData(){
      return this.dropdownContent;
    },
    getAddButtonText(){
      if(this.selectedDataCount){
        if(this.selectedDataCount == 1){
          return 'Add ' + this.selectedDataCount + " " + this.addButtonSingleText;
        }
        else{
          return 'Add ' + this.selectedDataCount + " " +this.addButtonText;
        }
      }
      else{
        return 'Add ' + this.addButtonText;
      }
    }
  },
  methods: {
    handleFocusOut(event) {
      if (!event.currentTarget.contains(event.relatedTarget)) {
        this.open = false;
      }
    },
    addDrodownData(event){
      this.$emit("onAddButtonClick", event);
      this.selectedData = [];
    }
  }
};
</script>

<style lang="scss">

.custom-select-box {
  position: relative;
  width: 100%;
  text-align: left;
  outline: none;
  font-size: 12px;
  font-weight: normal;
    .selected {
        border-radius: 4px;
        color: #4a4a4a;
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        text-transform: capitalize;
    }
    .add-step-button{
        height: 36px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        gap: 10px;
        padding: 8px 16px;
        border-radius: 4px;
        background-color: #4c8ce4;
        border: none;
        cursor: pointer;
    }
    .btn-opacity{
        opacity: 0.6;
        cursor: default;
    }
  
    .items {
      color: #4a4a4a;
      border-radius: 4px;
      position: absolute;
      background-color: #ffffff;
      left: 0px;
      right: 0px;
      top: 0px;
      box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.25);
      z-index: 1;
      min-width: 316px;
      max-height: 500px;
      padding: 16px;
      font-size: 14px;
      padding-right: 9px;
  
      .item {
        cursor: pointer;
        user-select: none;
        margin-bottom: 4px;
        &:hover {
          background-color: #f8f9fa;
        }
        &:last-of-type {
          margin-bottom: 0;
        }
  
        /*checkbox data*/
  
        label {
          width: 100%;
          cursor: pointer;
          display: flex;
          align-items: center;
  
        span {
          vertical-align: middle;
          margin-right: 5px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          width: 260px;
          display: inline-block;
        }
      }
  
      input[type="checkbox"] {
        display: none;
        height: 16px;
        width: 16px;
      }
  
      input[type="checkbox"]+span:before {
        content: "";
        border: 0.1em solid #959fa4;
        border-radius: 4px;
        width: 16px;
        height: 16px;
        padding: 4px;
        color: transparent;
        background-color: #fff;
        background-repeat: no-repeat;
        background-position: center center;
        display: inline-block;
        margin-top: 2px;
      }
  
      input[type="checkbox"]:checked+span:before {
        background-color: #4c8ce4;
        border: 0.1em solid #4c8ce4;
        color: #fff;
        background-image: url(/static/img/checked-checkbox.svg);
    }
      
    .step-body{    
        height: 15px;
        font-size: 12px;
        width: 260px;
        display: block;
        line-height: normal;
        text-align: left;
        color: #666669;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .step-title{
        width: 158px;
        height: 16px;
        font-size: 14px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: left;
        color: #4a4a4a;
    }
    }
  }
  .horizontal-divider{
    height: 15px;
    border-bottom: 1px solid #d3dee3;
    width: 316px;
    margin-left: -16px;
  }
  .select-hide {
    display: none;
  }
  .multi-select-height{
    overflow-x: hidden;
    overflow-y: auto;
    height: 223px;
    padding-top: 10px;
  }
  ::-webkit-scrollbar {
    width: 4px; /* width of the entire scrollbar */
  }

  scrollbar-width: thin;
  /* "auto" or "thin"  */
  scrollbar-color: #e6e9ed transparent;


  ::-webkit-scrollbar-track {
    background: transparent;
    /* color of the tracking area */
  }

  ::-webkit-scrollbar-thumb {
    background-color: #c5d1d6;
    /* color of the scroll thumb */
    border-radius: 20px;
    /* roundness of the scroll thumb */
    border: 3px solid transparent;
  /* creates padding around scroll thumb */
  }
}
</style>
